// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Provides a simple way to set the result of a promise at a later time.
 * Similar to .NETs TaskCompletionSource.
 */
export class PromiseCompletionSource<T> {
  private _reject: (reason: any) => void = undefined as any;
  private _resolve: (result: T) => void = undefined as any;

  readonly promise: Promise<T>;

  constructor()
  {
    this.promise = new Promise<T>((resolve, reject) =>
    {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  reject(reason: any): void
  {
    return this._reject(reason);
  }

  resolve(result: T): void
  {
    return this._resolve(result);
  }
}